/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FamilyAndShare
 */
export interface FamilyAndShare {
    /**
     * 
     * @type {string}
     * @memberof FamilyAndShare
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof FamilyAndShare
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof FamilyAndShare
     */
    url: string;
}

/**
 * Check if a given object implements the FamilyAndShare interface.
 */
export function instanceOfFamilyAndShare(value: object): value is FamilyAndShare {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function FamilyAndShareFromJSON(json: any): FamilyAndShare {
    return FamilyAndShareFromJSONTyped(json, false);
}

export function FamilyAndShareFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyAndShare {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'value': json['value'],
        'url': json['url'],
    };
}

export function FamilyAndShareToJSON(value?: FamilyAndShare | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'value': value['value'],
        'url': value['url'],
    };
}

